import { EDSign } from "@infotranssoft/eds";
const edsOptions = { proxy: process.env.VUE_APP_CIFRA };

const eds = new EDSign(edsOptions);

export default eds;
